"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ImageWithTextBlock() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="imagewithtextblock" className="w-full py-16 px-4 bg-background ![margin:-35px_0px_0px_0px] !h-[1000px]">
      <div className="container mx-auto max-w-6xl">
        <div ref={ref} className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="overflow-hidden shadow-medium">
            <CardContent className="p-0">
              <h2 className="font-bold text-center py-8 px-4 text-foreground !text-5xl">X Factor Leadership Development</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                {}
                <div className="relative min-h-[300px] !h-[900px]">
                  <Link to="https://www.amazon.com/World-Class-Brain-Performers-Succeed-Develop-ebook/dp/B0FBGW9W3J/ref=sr_1_1?crid=1WJ8C660XX8BT&dib=eyJ2IjoiMSJ9.X_iodIrHonKPoxrc3TUerDdkBR16dbDK84UV0NQaJS0ySqdGtZgE54O8J3EyUn4Q1Ohw9rda1PaBBoVM4yXtXXCSHWntoB6GLdlp8dZilHUXL39FDX0A_jQ4LjJzIy7EEVvuwK9EQdbuyIdqZpMCLHIepTBYPUFINAi9Qrb2RJdElK7f9aCn72VARgaH8ESFCBomM9IG7kcS-OtPmAIMwVEfqab-0z58Xg3AYK2H-Fc.HxiWzYKh1YB1qbDc98Dl3Nuyff7qjDwC_YKZZ6K0P20&dib_tag=se&keywords=world+class+brain&qid=1771216105&sprefix=world+class+brain%2Caps%2C156&sr=8-1" newTab rel="noopener noreferrer">
                    <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/world-class-brain1.jpg" alt="Visual representation" className="absolute inset-0 w-full object-cover !opacity-[1] ![padding:-50px_0px_-50px_0px] !m-0 !h-[850px]" />
                  </Link>
                </div>

                {}
                <div className="p-8 md:p-12 flex flex-col justify-center">
                  
                  <p className="text-muted-foreground leading-relaxed ![margin:-10px_0px_0px_0px] !text-xl">● Over 30,000 hours working with top CEOs developing even more leadership consciousness &amp; capacity to lead progress in the most evolutionary direction. <br /><br />● Over 20,000 hours training &amp; performing as top competitive athletes. <br /><br />● Over 70,000 hours (combined total of 25 years) as full-time meditating monks developing greater capacity of awareness, energy, clarity, coherence, creativity to deliver timely relevant insights to the CEOs &amp; executives. <br /><br />● Backed by a team of top integrative doctors &amp; neuroscientists to optimize mental and physical health.&nbsp; <br /><br /><br /><b data-ast-id="f:/src/pages/About/sections/ImageWithTextBlock.tsx|sig:pqsdtg" data-ast-start="2764" data-ast-end="2997">All this supports leaders having world class brain functioning to be &amp; stay in a peak performance state.</b><br /><br /><br /><br /><br /><br /><br /></p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}